<template>
  <div class="photoLottie" :ref="dynamicDef">
  </div>
</template>

<script>
import lottie from 'lottie-web';

export default {
  props: {
    dynamicDef: {
      type: String,
      defualt: ''
    },
    lottiePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      photoAni: {}
    };
  },
  mounted() {
    this.photoAni = lottie.loadAnimation({
      container: this.$refs[this.dynamicDef],
      renderer: 'svg',
      name: 'name',
      loop: true,
      autoplay: true,
      path: this.lottiePath
    });
    this.photoAni.setSubframe(false);
  }
};
</script>
